import { func, string } from "prop-types"
import styled from "styled-components"

const Wrapper = styled.div`
position: relative;
border: 1px solid red;
padding: 5px;

`

const Preview = styled.img`
width: 100%;
object-fit: contain;
max-width: 300px;
max-height: 200px;
`

const Button = styled.button`
 position: absolute;
  top: -5px;
  right: -5px;
  outline: none;
  border: none;
  background: red;
  width: 10px;
  height: 10px;
  color: white;
  border-radius: 100%;
  line-height: 10px;
  font-size: 6px;
  padding: 0;
  margin: 0;

`

const PreviewThumbnail = ({ onRemove, preview }) => {
  return <Wrapper>
    <Preview src={preview} alt="logo preview"/>
    <Button onClick={onRemove}>&times;</Button>
  </Wrapper>
}

PreviewThumbnail.propTypes = {
  preview: string.isRequired,
  onRemove: func.isRequired,
}

export default PreviewThumbnail
